module.exports = __webpack_public_path__ + "media/bootstrap-icons/cart2-d5488499.svg";